import NavigateLinksContainer from "../../../Components/UiKits/NavigateLinks/NavigateLinksContainer";

const NavigateLinks = () => {
  return <NavigateLinksContainer />;
};

export default NavigateLinks;
